module.exports = __webpack_public_path__ + "a2f70ac94ac021fe836e5acd30df98a9.svg";